module.exports = __webpack_public_path__ + "media/images/favicon/favicon-70-3ecbbb22f7ac7ed1cb1c98e3ab2fa361.png";